<script setup>
import { ref } from 'vue';
import { debounce } from 'lodash';
import axios from '../../libs/cifra/axios';

/*
Para los datos usamos por defecto formato select2:
{"results":[{"id":76211,"text":"Matemáticas"},{"id":55832,"text":"lengua"}]}
*/
const props = defineProps({
  url: { type: String, required: true },
  params: { type: Function, default: undefined },
});

const options = ref([]);
const loading = ref(false);
const select = ref(null);

const ajaxSearch = debounce((texto) => {
  loading.value = true;

  let params = { q: texto };
  if (props.params) {
    params = props.params(texto);
  }

  axios.get(props.url, { params }).then((result) => {
    options.value = result.data.results;
    loading.value = false;
  }).catch(() => {
    loading.value = false;
  });
}, 350);

const onSearch = (texto) => {
  if (texto.length) {
    ajaxSearch(texto);
  }
};

const load = () => {
  ajaxSearch('');
};

defineExpose({
  load,
});
</script>

<template>
  <select-cifra
    ref="select"
    :show-clear="true"
    :options="options"
    :loading="loading"
    :internal-search="false"
    label="text"
    track-by="id"
    @search-change="onSearch"
  >
    <template #option="{ option }">
      <slot name="option" :option="option">
        <span>{{ option.text }}</span>
      </slot>
    </template>
  </select-cifra>
</template>

<style lang="scss" scoped>
</style>
